export default __webpack_public_path__ + "static/media/element_spec_81.f43e8207.webp";